<template>
  <v-container fluid style="font-family: 'Montserrat', sans-serif">
    <v-row>
      <v-col cols="12" class="pa-0">
        <PrivacyPortalHeader />
      </v-col>
      <v-col cols="12" class="pa-0">
        <PrivacyOffice />
      </v-col>
      <v-col cols="12" class="pa-0">
        <PrivacyPortalFooter />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PrivacyPortalHeader from "@/components/PrivacyPortal/Header.vue";
import PrivacyPortalFooter from "@/components/PrivacyPortal/Footer.vue";
import PrivacyOffice from "@/components/PrivacyPortal/PrivacyOffice.vue";

export default {
  name: "PrivacyOfficeExternal",
  components: {
    PrivacyPortalHeader: PrivacyPortalHeader,
    PrivacyPortalFooter: PrivacyPortalFooter,
    PrivacyOffice: PrivacyOffice,
  },
};
</script>
